import { ArrowBack } from "@mui/icons-material";
import { IconButton, IconButtonProps, darken, styled } from "@mui/material";

interface Props extends IconButtonProps {}

export function StyledCollapseDrawerButton(props: Props) {
  return (
    <StyledIconButton {...props}>
      <ArrowBack />
    </StyledIconButton>
  );
}

const StyledIconButton = styled(IconButton)`
  &:hover {
    background-color: ${({ theme }) =>
      darken(theme.palette.background.default, 0.1)};
  }
`;
